import axios from 'axios'
import { SpendMetricsResponse } from 'src/models/spendMetrics.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import { SpendMetricsRequestParams } from 'src/queries/spendMetrics/spendMetrics.models'

export const getSpendMetrics = async (
  params: SpendMetricsRequestParams,
): Promise<SpendMetricsResponse> => {
  return getResponseData(
    axios.post<SpendMetricsResponse>(
      `/metrics/spend`,
      params,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
